import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { ParameterTypeEnum, type PlaceholderParameter } from './types.ts';

interface Props {
  parameter: PlaceholderParameter;
}

export function PlaceholderParameterFallbackInput(props: Props) {
  const { parameter } = props;

  if (parameter.type === ParameterTypeEnum.Number) {
    return (
      <FormItem name={parameter.id} label={parameter.label ?? parameter.id}>
        <NumberInput name={parameter.id} />
      </FormItem>
    );
  }

  return (
    <FormItem name={parameter.id} label={parameter.label ?? parameter.id}>
      <TextInput name={parameter.id} />
    </FormItem>
  );
}
